import { formatInteger, formatTime, toBerlinDateKey } from '@brimo/shared';

/** Texts of the dialer screens that are composed from figures (Terminierung 01–11). */

const NUMBER_WORDS = [
  'null',
  'einer',
  'zwei',
  'drei',
  'vier',
  'fünf',
  'sechs',
  'sieben',
  'acht',
  'neun',
  'zehn',
  'elf',
  'zwölf',
];

/** „aus vier Listen" / „aus einer Liste" / „aus 14 Listen". */
export function fromLists(count: number): string {
  if (count === 1) return 'aus einer Liste';
  const word = count >= 2 && count < NUMBER_WORDS.length ? NUMBER_WORDS[count] : formatInteger(count);
  return `aus ${word} Listen`;
}

/** „148 wählbare Kontakte" / „1 wählbarer Kontakt". */
export function dialableContacts(count: number): string {
  return count === 1 ? '1 wählbarer Kontakt' : `${formatInteger(count)} wählbare Kontakte`;
}

/**
 * The order clause of 01 from the API's order text: „19 Wiedervorlagen mit Vorrang, danach die neuesten Leads"
 * or „die neuesten Leads zuerst".
 */
export function orderClause(orderText: string, followUps: number): string {
  const newest = /neueste/i.test(orderText);
  const leads = newest ? 'die neuesten Leads' : 'die ältesten Leads';
  if (/^Wiedervorlagen/.test(orderText)) {
    const count = followUps === 1 ? '1 Wiedervorlage' : `${formatInteger(followUps)} Wiedervorlagen`;
    return `${count} mit Vorrang, danach ${leads}`;
  }
  return `${leads} zuerst`;
}

/** „31 / 44" */
export function ratio(dialable: number, total: number): string {
  return `${formatInteger(dialable)} / ${formatInteger(total)}`;
}

/** „Kontakte" or „Kontakt" after a count. */
export function contactsWord(count: number): string {
  return count === 1 ? 'Kontakt' : 'Kontakte';
}

const WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

function addDays(dayKey: string, days: number): string {
  const [year, month, day] = dayKey.split('-').map(Number) as [number, number, number];
  const date = new Date(Date.UTC(year, month - 1, day + days));
  return date.toISOString().slice(0, 10);
}

/** Today in Berlin as YYYY-MM-DD. */
export function todayKey(now: Date = new Date()): string {
  return toBerlinDateKey(now);
}

export function dayKeyPlus(dayKey: string, days: number): string {
  return addDays(dayKey, days);
}

/** The day heading of the free slots: „Heute, 16.09." · „Morgen, 17.09." · „Donnerstag, 18.09.". */
export function slotDayLabel(dayKey: string, today: string): string {
  const [year, month, day] = dayKey.split('-').map(Number) as [number, number, number];
  const date = `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.`;
  if (dayKey === today) return `Heute, ${date}`;
  if (dayKey === addDays(today, 1)) return `Morgen, ${date}`;
  const weekday = WEEKDAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()] ?? '';
  return `${weekday}, ${date}`;
}

/** „10:30" in Berlin. */
export function slotTime(startsAt: string): string {
  return formatTime(startsAt);
}
